"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./modal.interface"), exports);
tslib_1.__exportStar(require("./uploaded-file.interface"), exports);
tslib_1.__exportStar(require("./modal-body.interface"), exports);
tslib_1.__exportStar(require("./modal-result.interface"), exports);
